import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";

function StaticTypeWriter(props) {
    const [currentText, setCurrentText] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const delay = 10;
    const effects = props.effects === false ? false : true;
    
    useEffect(() => {
          if (effects && props.text) {
            if (currentIndex < props.text.length) {
              const timeout = setTimeout(() => {
                const displayedText = currentText;
                setCurrentText((prevText) => prevText + props.text[currentIndex]);
                setCurrentIndex((prevIndex) => prevIndex + 1);
                if (props.text.length - 1 <= displayedText.length) {
                  props.setLoading(true);
                } 
              }, delay);
              return () => clearTimeout(timeout);
            } else {
              const displayedText = currentText;
              if (props.text.length - 1 <= displayedText.length) {
                props.setLoading(true);
              } 
          } 
        } else {
          props.setLoading(true);
        }
      }, [
        currentIndex,
        props.text,
      ]);
      
    return (
        <div className="staticTypeWriter">
            {
                effects === true ?
                    <Markdown>{currentText}</Markdown>   
                :
                    <Markdown>{props.text}</Markdown>
            }
        </div>
    );
}

export default StaticTypeWriter;